import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark} from '@fortawesome/free-solid-svg-icons'

export const ActiveAndInactive = ({status, handleActiveAndInActive, statusId}) => {

    return(
        <React.Fragment>
           <div className="custom-button">
            { status === false ? <button className="approved-btn" onClick={() => handleActiveAndInActive(statusId)} ><FontAwesomeIcon icon={faCircleCheck} /> Active</button>  : <button className="unapproved-btn" onClick={() => handleActiveAndInActive(statusId)} > <FontAwesomeIcon icon={faCircleXmark} /> Inactive</button>  }            
           </div>
        </React.Fragment>
    )
}